import React from 'react';

import whiteBoxxx from '../../assets/discountPage/thewhiteboxxx-com-c1278867.jpg';
import mrSkin from '../../assets/discountPage/mr-skin-da4931d0.jpg';
import eroticaX from '../../assets/discountPage/eroticax-1dcd41ad.jpg';
import ersties from '../../assets/discountPage/ersties-com-1c593582.jpg';
import nubilesPorn from '../../assets/discountPage/nubiles-porn-com-1e1ae907.jpg';
import petite from '../../assets/discountPage/petite-hd-porn-ee33e77b.jpg';
import playboy from '../../assets/discountPage/playboy-tv-6334372e.jpg';
import nakedNewsCams from '../../assets/discountPage/naked-news-cams-654415a5.jpg?1534187291';
import sexArt from '../../assets/discountPage/sexart-318f8772.jpg?1534187491';
import metArt from '../../assets/discountPage/metart-5f31aef6.jpg?1534187657';

import './css/DiscountPage.css';


class ExternalPartnerDiscountPage extends React.Component {

  render() {
    return (
      <div className="content">
        <div className="container">
          <div id="member-specials">
            <div className="header">
              <h1>Special Offers for Naked News Members</h1>
              <div className="lead">
                <p className="text-muted">We ve negotiated the lowest prices available on some of our favorite sites on the internet.</p>
                <p className="text-muted">Naked News members can take advantage of these amazing deals and save big!</p>
              </div>
            </div>
            <div className="row-r">
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://join.porndoepremium.com/track/Nzg1LjUuMi4xNjIuMS4wLjAuMC4w" rel="noreferrer" target="_blank">
                      <img alt="TheWhiteBoxxx.com " className="img-responsive" src={whiteBoxxx} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://join.porndoepremium.com/track/Nzg1LjUuMi4xNjIuMS4wLjAuMC4w" rel="noreferrer" target="_blank">
                        {'TheWhiteBoxxx.com '}
                      </a>
                      <a className="sub-title" href="http://join.porndoepremium.com/track/Nzg1LjUuMi4xNjIuMS4wLjAuMC4w" rel="noreferrer" target="_blank">
                        <small>
                          60% OFF!
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>Unlock your secret desires at WhiteBoxxx!</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://www.mrskin.com/tour?_atc=888591-231-1-70772" rel="noreferrer" target="_blank">
                      <img alt="Mr. Skin" className="img-responsive" src={mrSkin} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://www.mrskin.com/tour?_atc=888591-231-1-70772" rel="noreferrer" target="_blank">
                        {'Mr. Skin '}
                      </a>
                      <a className="sub-title" href="http://www.mrskin.com/tour?_atc=888591-231-1-70772" rel="noreferrer" target="_blank">
                        <small>
                          $5 Intro Month
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>Hot celebrity nudes, "Fast Fowarding to the Good Parts!"</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://www.blazinglink.com/eroticax/go.php?pr=12&amp;su=1&amp;si=66&amp;pa=index&amp;ar=&amp;ad=270030&amp;campaign=38421" rel="noreferrer" target="_blank">
                      <img alt="EroticaX" className="img-responsive" src={eroticaX} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://www.blazinglink.com/eroticax/go.php?pr=12&amp;su=1&amp;si=66&amp;pa=index&amp;ar=&amp;ad=270030&amp;campaign=38421" rel="noreferrer" target="_blank">
                        {'EroticaX '}
                      </a>
                      <a className="sub-title" href="http://www.blazinglink.com/eroticax/go.php?pr=12&amp;su=1&amp;si=66&amp;pa=index&amp;ar=&amp;ad=270030&amp;campaign=38421" rel="noreferrer" target="_blank">
                        <small>
                          50% OFF
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>Come and experience the softer, intimate side of porn on EroticaX. Watch sexy women &amp; gorgeous pornstars in erotic seduction fantasies &amp; porn for couples.</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://ersties.com/tourpage?w=1081.SpecialsPage" rel="noreferrer" target="_blank">
                      <img alt="Ersties.com" className="img-responsive" src={ersties} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://ersties.com/tourpage?w=1081.SpecialsPage" rel="noreferrer" target="_blank">
                        {'Ersties.com '}
                      </a>
                      <a className="sub-title" href="http://ersties.com/tourpage?w=1081.SpecialsPage" rel="noreferrer" target="_blank">
                        <small>
                          60% OFF
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>100% Real Girls Experiencing 100% Real Intimate Moments! Amateur girls from the street every single day!</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://nubiles-porn.com/?coupon=13545" rel="noreferrer" target="_blank">
                      <img alt="Nubiles-porn.com" className="img-responsive" src={nubilesPorn} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://nubiles-porn.com/?coupon=13545" rel="noreferrer" target="_blank">
                        {'Nubiles-porn.com '}
                      </a>
                      <a className="sub-title" href="http://nubiles-porn.com/?coupon=13545" rel="noreferrer" target="_blank">
                        <small>
                          33% OFF
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>Tiny and Petite HD PORN teens get fucked! Best sex, best cameras and the most petite models.</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://petitehdporn.com/tube/featured?coupon=13545" rel="noreferrer" target="_blank">
                      <img alt="Petite HD Porn" className="img-responsive" src={petite} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://petitehdporn.com/tube/featured?coupon=13545" rel="noreferrer" target="_blank">
                        {'Petite HD Porn '}
                      </a>
                      <a className="sub-title" href="http://petitehdporn.com/tube/featured?coupon=13545" rel="noreferrer" target="_blank">
                        <small>
                          50% OFF
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>Worlds most PETITE and SMALL and TINY girls having Hot Sex!</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://join.playboy.tv/track/MTAyNDcxMS4xMDQ2MS4xMDMxLjI3MDEuNS4wLjAuMC4w" rel="noreferrer" target="_blank">
                      <img alt="Playboy TV" className="img-responsive" src={playboy} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://join.playboy.tv/track/MTAyNDcxMS4xMDQ2MS4xMDMxLjI3MDEuNS4wLjAuMC4w" rel="noreferrer" target="_blank">
                        {'Playboy TV '}
                      </a>
                      <a className="sub-title" href="http://join.playboy.tv/track/MTAyNDcxMS4xMDQ2MS4xMDMxLjI3MDEuNS4wLjAuMC4w" rel="noreferrer" target="_blank">
                        <small>
                          7 DAY FREE TRIAL
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>Playboy the hottest centerfolds, playboy playmates!</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://nakednewscams.com/?AFNO=1-301" rel="noreferrer" target="_blank">
                      <img alt="Naked News Cams" className="img-responsive" src={nakedNewsCams} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://nakednewscams.com/?AFNO=1-301" rel="noreferrer" target="_blank">
                        Naked News Cams
                      </a>
                      <a className="sub-title" href="http://nakednewscams.com/?AFNO=1-301" rel="noreferrer" target="_blank">
                        <small />
                      </a>
                    </div>
                    <div className="description">
                      <p>Hottest Cam Girls for your viewing pleasure. They want to talk to you!</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://refer.ccbill.com/cgi-bin/clicks.cgi?CA=901313&amp;PA=2454533&amp;HTML=http://www.sexart.com/?special=1" rel="noreferrer" target="_blank">
                      <img alt="SexArt" className="img-responsive" src={sexArt} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://refer.ccbill.com/cgi-bin/clicks.cgi?CA=901313&amp;PA=2454533&amp;HTML=http://www.sexart.com/?special=1" rel="noreferrer" target="_blank">
                        {'SexArt '}
                      </a>
                      <a className="sub-title" href="http://refer.ccbill.com/cgi-bin/clicks.cgi?CA=901313&amp;PA=2454533&amp;HTML=http://www.sexart.com/?special=1" rel="noreferrer" target="_blank">
                        <small>
                          33% Off
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>High-end erotica - Erotic reality programming to eye-opening sexual documentaries</p>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-6 col-sm-12">
                <div className="specials well">
                  <div className="item-header text-center">
                    <a href="http://refer.ccbill.com/cgi-bin/clicks.cgi?CA=901313&amp;PA=2454533&amp;http://guests.met-art.com/?trial=2" rel="noreferrer" target="_blank">
                      <img alt="MetArt" className="img-responsive" src={metArt} />
                    </a>
                  </div>
                  <div className="item-body text-muted">
                    <div className="title">
                      <a className="name" href="http://refer.ccbill.com/cgi-bin/clicks.cgi?CA=901313&amp;PA=2454533&amp;http://guests.met-art.com/?trial=2" rel="noreferrer" target="_blank">
                        {'MetArt '}
                      </a>
                      <a className="sub-title" href="http://refer.ccbill.com/cgi-bin/clicks.cgi?CA=901313&amp;PA=2454533&amp;http://guests.met-art.com/?trial=2" rel="noreferrer" target="_blank">
                        <small>
                          33% OFF
                        </small>
                      </a>
                    </div>
                    <div className="description">
                      <p>Metart is the worlds finest and most successful erotic softcore photography site.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ExternalPartnerDiscountPage;
